import Component from './select_form.vue'
export default Component
